import _defineProperty from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import "core-js/modules/esnext.string.replace-all.js";
import React from 'react';
import { Box, Container, Grid, TAGTypography, TAGSvgIcon, TAGButton, useTheme, useMediaQuery, TermsAndConditions } from '../../';

var SingleMessage = function SingleMessage(_ref) {
  var _sx;

  var _ref$backgroundColor = _ref.backgroundColor,
      backgroundColor = _ref$backgroundColor === void 0 ? 'white' : _ref$backgroundColor,
      branding = _ref.branding,
      _ref$buttonSize = _ref.buttonSize,
      buttonSize = _ref$buttonSize === void 0 ? 'large' : _ref$buttonSize,
      buttonText = _ref.buttonText,
      _ref$buttonType = _ref.buttonType,
      buttonType = _ref$buttonType === void 0 ? 'Secondary Default' : _ref$buttonType,
      buttonUrl = _ref.buttonUrl,
      description = _ref.description,
      eyebrow = _ref.eyebrow,
      _ref$fullWidth = _ref.fullWidth,
      fullWidth = _ref$fullWidth === void 0 ? true : _ref$fullWidth,
      icon = _ref.icon,
      subText = _ref.subText,
      tc = _ref.tc,
      title = _ref.title,
      _ref$titleVariant = _ref.titleVariant,
      titleVariant = _ref$titleVariant === void 0 ? 'h1' : _ref$titleVariant;
  var isDark = backgroundColor === 'dark';
  var theme = useTheme();
  var isSmall = useMediaQuery(theme.breakpoints.down('md'));

  var changeSym = function changeSym(str) {
    var copyright = str.replace(/\(C\)*/gi, '©');
    var tm = copyright.replaceAll(/\(TM\)*/gi, '™');
    var registered = tm.replaceAll(/\(R\)*/gi, '®');
    return registered;
  };

  var buttonVariant = function buttonVariant() {
    if (buttonType === 'Secondary Default') {
      return isDark ? 'Secondary High Contrast' : buttonType;
    } else {
      return isDark ? 'Tertiary High Contrast' : buttonType;
    }
  };

  return React.createElement(Grid, {
    sx: fullWidth ? {
      backgroundColor: "backgrounds.".concat(backgroundColor),
      height: '100%'
    } : {
      height: '100%'
    }
  }, React.createElement(Container, {
    sx: (_sx = {}, _defineProperty(_sx, theme.breakpoints.down('sm'), {
      paddingLeft: '0',
      paddingRight: '0'
    }), _defineProperty(_sx, "display", 'flex'), _defineProperty(_sx, "height", '100%'), _sx)
  }, React.createElement(Box, {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "center",
    sx: {
      bgcolor: "backgrounds.".concat(backgroundColor),
      padding: {
        xs: '40px 10px',
        md: '40px 10px'
      },
      borderRadius: {
        sm: !fullWidth ? '8px' : '0px'
      },
      flex: 1
    }
  }, icon && React.createElement(TAGSvgIcon, {
    icon: icon,
    size: 64
  }), eyebrow && React.createElement(TAGTypography, {
    variant: isSmall ? 'bodySmallBook' : 'bodyMediumBook',
    color: isDark ? 'text.light' : 'text.secondary',
    sx: {
      margin: '12px 0'
    }
  }, eyebrow), title && React.createElement(TAGTypography, {
    color: isDark ? 'primary.light' : 'primary',
    variant: titleVariant,
    sx: {
      mb: {
        md: '16px',
        sm: '24px',
        xs: '24px'
      },
      textAlign: 'center'
    }
  }, changeSym(title)), subText && React.createElement(TAGTypography, {
    color: isDark ? 'primary.light' : 'primary',
    fontStyle: "h4",
    sx: {
      mb: {
        md: '12px',
        sm: '24px',
        xs: '24px'
      }
    }
  }, subText), (description === null || description === void 0 ? void 0 : description.description) && React.createElement(TAGTypography, {
    color: isDark ? 'text.light' : 'text.secondary',
    variant: isSmall ? 'bodyMediumBook' : 'bodyLargeBook',
    sx: {
      mb: {
        md: '40px',
        sm: '32px',
        xs: '32px'
      },
      textAlign: 'center',
      maxWidth: '830px',
      flex: 1
    }
  }, changeSym(description.description)), buttonText && buttonUrl && buttonType && React.createElement(TAGButton, {
    buttonVariant: buttonVariant(),
    buttonSize: buttonSize,
    defaultButtonVariant: "Secondary Default",
    sx: {
      width: {
        xs: '100%',
        sm: 'auto',
        md: 'auto'
      },
      mb: '20px'
    },
    href: buttonUrl
  }, buttonText), tc && React.createElement(TermsAndConditions, _objectSpread(_objectSpread({}, tc), {}, {
    branding: branding,
    isDark: isDark
  })))));
};

export default SingleMessage;